;var toggleButtons = (function ($, window) {
    
    var toggleButtons = function ($element,data) {
        
        this.$target=$element;
        this.options=data.subnavtogglebutton;//targetElement, activeClass
        this.buttonHtml = '<button class="icn toggleSubNav">toggle</button>';
        
        this._init();

    }
    
    toggleButtons.prototype._init = function() {
        var self=this;
        
        this.$target
            .find(self.options.targetElement)
            .each(function(){
                var obj = $(this);
                
                self._createToggleButton(obj);
            })
    };
    
    
    toggleButtons.prototype._createToggleButton = function(obj) {
        var self = this,
            html = self.buttonHtml,
            $el = $(html);
        
                   
        $el.on('click', function(e){
            var btn = $(this);
           
            btn.toggleClass(self.options.activeClass);
               
            e.preventDefault(); 
        });
        
        //place button before subnav element
        obj
        .children(self.options.subnavElement)
        .before($el)
    };
    
    
    /**
     * On DOM ready
     */
    $(function () {
        /**
         * Initialize wizard for all elements tagged with `[max-words]`
         */
        var initNav = function () {
    
            $('[data-subnavToggleButton]').each(function () {
                var $target = $(this),
                    options = $target.data();
                
                new toggleButtons($target, options);
            });
        };
       
        initNav();
    });

})(jQuery, window);
